import { useCallback, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { notificationApiRef } from '../../../../../apis/notificationApi';
import { toolsProvisioningApiRef } from '../../../../../apis/toolsProvisioningApi';
import { toTestSuites } from '../dto/responseDto/runResults.response.dto';
import type { IIqeRunResultsRequest } from '../interfaces/api/requests/runResults.request';
import type { ITestSuite } from '../interfaces/ui';

export const useExecutionTestCases = () => {
  const notificationApi = useApi(notificationApiRef);
  const toolsProvisioningApi = useApi(toolsProvisioningApiRef);
  const [data, setData] = useState<ITestSuite[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const clearError = useCallback(() => setError(null), []);
  const reset = useCallback(() => {
    setData([]);
    setLoading(false);
    setError(null);
  }, []);

  const fetchTestCases = useCallback(
    async (request: IIqeRunResultsRequest) => {
      setLoading(true);
      setError(null);
      try {
        const response = await toolsProvisioningApi.getIqeTestPlan(request);
        setData(toTestSuites(response));
      } catch (requestError) {
        const message = `Error occurred - ${requestError}`;
        setError(message);
      } finally {
        setLoading(false);
      }
    },
    [notificationApi, toolsProvisioningApi],
  );

  return { data, loading, error, clearError, reset, fetchTestCases };
};
